<h2 mat-dialog-title mat-dialog-draggable-title style="margin-bottom: 0px !important;">
    {{data.contractName}}
    <button type="button" class="close" aria-label="Close" (click)="onNoClick()">
      <span aria-hidden="true">&times;</span>
    </button>
  </h2>
  <mat-divider></mat-divider>
  <div class="row">
    <div style="width: 100%; position: relative; height: 52px; display: flex; align-items: center; background: #fff;">
        <div class="d-flex box-tab" style="width: 100%; margin-top: 0.5rem; height: 44px">
          <div class="pl-2 py-2 tab d-flex" *ngFor="let file of data.filesName; let i = index"
            [class.active]="i === activeFile" [class.left]="i === activeFile - 1" [class.right]="i === activeFile + 1"
            [class.border-right]="i !== data.filesName.length - 1 && i !== activeFile && i !== activeFile - 1"
            (click)="changeFile(i)" [matTooltip]="file">
            <div class="name">
              {{ file }}
            </div>
          </div>
          <button mat-stroked-button class="mr-2 btn-download-file-sm desktop" color="primary"
                  (click)="openPDFByBrowser(data.idDocument)">
            <mat-icon class="mr-0">save_alt</mat-icon>
            {{ "enterprise_contract.buttons.download" | translate }}
          </button>
          <button (click)="doPrint()" mat-stroked-button class="mr-2 btn-download-file-sm desktop" color="primary" *ngIf="data.checkMan != 1">
            <mat-icon class="mr-0">print</mat-icon>
            {{ "enterprise_contract.buttons.print" | translate }}
          </button>
        </div>
      </div>
      <div class="d-flex justify-content-center px-5 w-100" style="height: calc(90vh - 150px)" *ngIf="pdfSrc === 'notPDF'">
        <h5 class="mt-5 d-flex">
          {{"digital_contract.error.fileNotSupportPreview_Digital_First" | translate }} &nbsp; <u (click)="openPDFByBrowser(data.idDocument)">{{"digital_contract.error.fileNotSupportPreview_Digital_Medium" | translate}}</u> &nbsp; {{"digital_contract.error.fileNotSupportPreview_Digital_Last" | translate }}
        </h5>
      </div>
      <ng-container *ngIf="pdfSrc !== 'notPDF'">
        <ng-container *ngIf="pdfSrc !== 'notPDF'">
          <ngx-extended-pdf-viewer class="pdf-viewer" [src]="pdfSrc" useBrowserLocale="true"
            [showDownloadButton]="false" [showRotateButton]="false" [showOpenFileButton]="false"
            [showBookmarkButton]="false" [showPropertiesButton]="false" [showUnverifiedSignatures]="true"
            [sidebarVisible]="true" [enablePrint]="false" [theme]="'dark'" [language]="language"
            height="calc(90vh - 150px)" style="display: block; width: 100%;" [showSecondaryToolbarButton]="false"
            [textLayer]="true" [httpHeaders]="authorization"
            [zoom]="'page-width'">
          </ngx-extended-pdf-viewer>
        </ng-container>
      </ng-container>
  </div>
  <!-- (textLayerRendered)="textLayerFormRendered($event)" -->
